import { formatAsShortDate } from "../../../core/helpers/date-formatting-util.js";
import { router } from "@foretagsplatsen/widgetjs";
import DimensionSpecification from "../../../models/dimensionSpecification/DimensionSpecification.js";

/**
 * This renders a transaction row in a LedgerEntryTableWidget.
 *
 * @param {Transaction} spec.transaction - The report to which the row belongs to
 * @param {string} spec.dimensionIdentifier - dimensionIdentifier is used as a parameter for linking to
 * a account-statement.
 * @param {Renderer} spec.numberRenderer - will be called with a number and expects it returned formatted.
 */
function ledgerEntryTransactionRenderer({
	transaction,
	dimensionIdentifier,
	numberRenderer,
}) {
	return (html) => {
		const account = transaction.getAccount();
		const isDebitAmount = transaction.getAmount() > 0;
		html.td(transaction.getTextOrLedgerEntryText());
		html.td().renderNonBreaking(formatAsShortDate(transaction.getDate()));
		html.td(account.getName());

		html.td(
			{ klass: "text-right" },
			html.a(account.getNumber()).href(
				router.getRouter().linkTo("account-statement", {
					accountNumber: account.getNumber(),
					dimensionSpecification:
						dimensionIdentifier &&
						new DimensionSpecification({
							dimensionId: dimensionIdentifier,
						}).toString(),
				}),
			),
		);

		const debitTotalCell = html.td({
			klass: "text-right",
			nowrap: "nowrap",
		});
		const creditTotalCell = html.td({
			klass: "text-right",
			nowrap: "nowrap",
		});

		isDebitAmount
			? debitTotalCell.renderNonBreaking(
					numberRenderer(transaction.getAmount()),
				)
			: creditTotalCell.renderNonBreaking(
					numberRenderer(transaction.getReversedAmount()),
				);
	};
}

export default ledgerEntryTransactionRenderer;
